export const BASE_URL = "http://103.200.74.95:8009";
// export const BASE_URL = "http://103.200.74.214:8008";
